import { schemaAlterne } from '../custody/schemas.js';
/**
 * Les catégories du dossier — la liste fermée sur laquelle s'accordent l'API, le web
 * et, demain, le mobile.
 *
 * Elles remplacent l'empilement de dix cartes de la première version. Ce n'est pas un
 * choix cosmétique : un parent qui ouvre Repère cherche une chose précise — savoir chez
 * qui dort l'enfant ce soir, répondre à un message, retrouver une facture — et la faire
 * chercher dans une page qui déroule tout impose un coût à chaque visite, tous les jours,
 * pendant des années.
 *
 * L'ordre compte : il va du plus quotidien au plus consultatif, et c'est l'ordre dans
 * lequel les catégories s'affichent.
 */
export const CATEGORIES_DOSSIER = [
    'aujourdhui',
    'calendrier',
    'messages',
    'depenses',
    'journal',
    'enfants',
];
export const LIBELLES_CATEGORIES = {
    aujourdhui: "Aujourd'hui",
    calendrier: 'Calendrier',
    messages: 'Messages',
    depenses: 'Dépenses',
    journal: 'Journal',
    enfants: 'Enfants',
};
/**
 * Où se lit le fait qu'une notification annonce.
 *
 * La correspondance est totale et vérifiée par un test : une nouvelle sorte de
 * notification sans catégorie d'accueil produirait une pastille qui ne mène nulle part.
 *
 * `journal` n'apparaît volontairement pas ici — le journal ne déclenche aucune
 * notification, et n'en déclenchera pas : y consigner un fait n'est pas s'adresser à
 * l'autre parent. La catégorie ne porte donc jamais de pastille, et c'est cohérent.
 *
 * `document_new` échoit à `enfants` faute de module Documents dans le dossier web : un
 * document déposé concerne un enfant, sa fiche est l'endroit le moins arbitraire. Le jour
 * où les documents ont leur écran, ils prennent leur propre catégorie.
 */
export const CATEGORIE_PAR_NOTIFICATION = {
    message_new: 'messages',
    proposal_new: 'aujourdhui',
    proposal_answered: 'aujourdhui',
    expense_new: 'depenses',
    document_new: 'enfants',
    calendar_event_new: 'calendrier',
    alert_new: 'aujourdhui',
    professional_invited: 'aujourdhui',
    // L'écriture ouverte ne concerne aucune catégorie en particulier — elle les concerne
    // toutes. « Aujourd'hui » est l'écran qu'on ouvre en arrivant, donc le seul endroit d'où
    // la nouvelle ne renvoie pas vers un module plutôt qu'un autre.
    writing_opened: 'aujourdhui',
};
/** Vrai si la chaîne est une catégorie connue. Sert de garde aux entrées non typées. */
export function estCategorieDossier(valeur) {
    return CATEGORIES_DOSSIER.includes(valeur);
}
/**
 * Nom par défaut d'un dossier : « Garde alternée de Léa et Noé ».
 *
 * Le préfixe **suit le schéma réel**. Un dossier en week-ends alternés n'est pas une garde
 * alternée : l'écrire en tête de l'écran le plus consulté du produit serait une affirmation
 * fausse sur la situation d'une famille — et, dans un dossier qu'un avocat peut lire, une
 * affirmation fausse qui a l'air officielle. Tant qu'aucun schéma n'est posé, on s'en tient
 * à « Garde de… », qui n'engage rien.
 *
 * Ce nom n'est **pas enregistré** : il se recalcule à l'affichage. Un enfant qui rejoint le
 * dossier, un schéma qui change, et un nom figé en base deviendrait faux sans que personne
 * ne le sache.
 */
export function nomParDefautDossier(prenoms, schema) {
    if (prenoms.length === 0)
        return 'Dossier';
    const liste = prenoms.length === 1
        ? prenoms[0]
        : `${prenoms.slice(0, -1).join(', ')} et ${prenoms.at(-1)}`;
    const prefixe = schema && schemaAlterne(schema) ? 'Garde alternée' : 'Garde';
    return `${prefixe} de ${liste}`;
}
//# sourceMappingURL=categories.js.map